import * as React from "react";
import { createIcon } from "@chakra-ui/react";

const CheckCircleFilled = createIcon({
  path: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1.41 14.59L6.7 12.7l1.41-1.41 2.48 2.48 5.3-5.3 1.41 1.41-6.71 6.71z"
      fill="currentColor"
    />
  ),
  viewBox: "0 0 24 24",
});

export { CheckCircleFilled };
